import React from "react";
import Links from "../sub-components/Links";
const { PUBLIC_URL } = process.env;

const Feature4 = () => {
  const dashboard_Video = process.env.REACT_APP_DASHBOARD_VIDEO;

  return (
    
      <div>
        <section className="section main-banner" id="f4top">
          <video autoPlay muted loop id="bg-video">
            <source
              src={dashboard_Video}
              type="video/mp4"
            />
          </video>

          <div className="video-overlay header-text">
            <div className="caption">
              <h4 style={{ color: "#f5a425" }}>
                Solutions that adjust to your needs
              </h4>
              <h6>
                Add your special touch to our clean and simple design. All users
                have the option <br />
                to easily customize their assessments with their logo or
                configure a custom subdomain.
              </h6>

              <div className="main-button">
                <div className="scroll-to-section">
                  <a href={`${PUBLIC_URL}/#section3`}>Sign up - it's free</a>
                </div>
              </div>
              <br />
              {/* <div>
                <a style={{ fontSize: "16px", color: "white" }}>Learn more</a>
                <br />
                <GoArrowDown style={{ color: "white" }} />
              </div> */}
            </div>
          </div>
        </section>

        <section className="dark-bg2">
          <div className="container-fluid dark-bg2-sec">
            <div className="row f4sec1">
              <div className="col-md-12 col-lg-6 f4sec1img">
                <article className="video-item ">
                  <figure>
                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/custom-tp1.webp`}
                      alt=""
                    />
                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/green_l_r.svg`}
                      alt=""
                      className="green_l_r"
                    />

                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/green_r_l.svg`}
                      alt=""
                      className="green_r_l"
                    />
                  </figure>
                </article>
              </div>
              <div className="col-lg-6 f4sec1content">
                <h3>Make it personal. Stand out from the crowd.</h3>
                <p>
                  Add something special on top of our clean and simple design.
                  You can easily upgrade your assessments with a logo or
                  configure a custom subdomain, and it’s a standard option for
                  all users.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="img-bg">
          <div className="container-fluid img-bg-sec">
            <div className="row f4sec2">
              <div className="col-lg-12 f4sec2head">
                <h4>
                  Test-creating software with amazing customization options
                </h4>
                <h2>Online assessments that are truly yours</h2>
              </div>

              <div className="col-lg-1"></div>
              <div className="col-lg-2 f4sec2content1">
                <h3>White label</h3>
                <p>
                  Hide NexTestify logos and present your assessments under your
                  own brand.
                </p>
              </div>

              <div className="col-lg-2 f4sec2content1">
                <h3>Show your brand colors</h3>
                <p>
                  Test sheets are fully customizable. Need your company colors?
                  Let us know and we’ll make it happen.
                </p>
              </div>
              <div className="col-lg-2 f4sec2content1">
                <h3>Add or change assessment features</h3>
                <p>
                  Our online test maker can add individualized functionalities
                  to make assessments fit for any purpose. Changes may include
                  test font, custom logo, etc.
                </p>
              </div>
              <div className="col-lg-2 f4sec2content1">
                <h3>Additional notifications</h3>
                <p>
                  If you require additional notification options, such as the
                  ability to manage messages within your organization,
                  NexTestify will be happy to provide a solution that works for
                  you.
                </p>
              </div>
              <div className="col-lg-2 f4sec2content1">
                <h3>Consents</h3>
                <p>
                  Make sure you have all consents required by law. NexTestify
                  will assist you in collecting all the necessary permissions
                  before your respondents take a test.
                </p>
              </div>
              <div className="col-lg-1"></div>
            </div>
          </div>
        </section>

        <section className="light-bg">
          <div className="container-fluid light-bg-sec">
            <div className="row f4sec3">
              <div className="col-lg-6 f4sec3content">
                <h3>Seamless integration with your system</h3>
                <p>
                  Direct unification of NexTestify assessments with your website
                  or software is a game-changer that saves time and money. Make
                  all tests appear as if they are inseparable parts of your
                  site. Because they will be.
                </p>
                <div className="main-button">
                  {/* <a>Read more</a> */}
                  <span>Read more</span>
                </div>
              </div>

              <div className="col-md-12 col-lg-6 f4sec3img">
                <article className="video-item ">
                  <figure>
                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/custom-tp2.webp`}
                      alt=""
                    />
                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/purple_curve_bottom.svg`}
                      alt=""
                      className="purple_curve_bottom"
                    />

                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/yellow_curve_top.svg`}
                      alt=""
                      className="yellow_curve_top"
                    />
                  </figure>
                </article>
              </div>
            </div>
          </div>
        </section>

        <section className="dark-bg">
          <div className="container-fluid dark-bg-sec">
            <div className="row f4sec4">
              <div className="col-md-12 col-lg-6 f4sec4img">
                <article className="video-item ">
                  <figure>
                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/custom-tp3.webp`}
                      alt=""
                    />
                  </figure>
                </article>
              </div>
              <div className="col-lg-6 f4sec4content">
                <h3>Make it personal. Stand out from the crowd.</h3>
                <p>
                  Add something special on top of our clean and simple design.
                  You can easily upgrade your assessments with a logo or
                  configure a custom subdomain, and it’s a standard option for
                  all users.
                </p>
              </div>
            </div>
          </div>
        </section>

        <Links />
      </div>
    
  );
};

export default Feature4;
